import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import QuoteLayout from "../pages/common/component/QuoteLayout";
import { Phone } from "../pages/phone/component/Phone";
import { Quote } from "../pages/quote/component/Quote";
import { useAuth } from "./AuthProvider";

export const QuoteRoute = () => {
  const { userDetails } = useAuth();
  const [isShow, setIsShow] = useState(false);

  return (
    <Routes>
      <Route element={<QuoteLayout isShow={isShow} setIsShow={setIsShow} />}>
        {userDetails ? (
          <Route
            path="request"
            element={<Quote isShow={isShow} setIsShow={setIsShow} />}
          />
        ) : (
          <Route path="phone" element={<Phone />} />
        )}
        <Route path="view/:quoteId" element={<Phone />} />
        <Route
          path="*"
          element={<Navigate to={userDetails ? "request" : "phone"} />}
        />
      </Route>
    </Routes>
  );
};
